import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { wrapMixedLocaleBidiLabels } from '../utils/mixed-locale-bidi';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private labels = new BehaviorSubject<any>(null);
    private countries = new BehaviorSubject<any>({});
    private userInfo = new BehaviorSubject<any>({});
    private isLoginPage = new BehaviorSubject<any>(false);
    private remainingUpload = new BehaviorSubject<number>(-1);
    private remainingDigitalUpload = new BehaviorSubject<number>(-1);
    private isDocRefresh = new BehaviorSubject(false);
    private isResetSection = new BehaviorSubject(false);
    private docId = new BehaviorSubject(null);
    private document = new BehaviorSubject(null);
    private pageType=new BehaviorSubject(null);
    private documentDelete=false;
    private isPinSource = new BehaviorSubject<boolean>(false);
    currentIsPin = this.isPinSource.asObservable()
    private documentInfoFromExt = new BehaviorSubject<any>({});

    private selectedCardSource = new BehaviorSubject<number | null>(null);
    selectedCard$ = this.selectedCardSource.asObservable();

    private pinCodeSubject = new BehaviorSubject<string | null>(null);
    currentPinCode = this.pinCodeSubject.asObservable();

  private pinHistoryCodeSubject = new BehaviorSubject<string | null>(null);
    currentpinHistoryCode = this.pinHistoryCodeSubject.asObservable();

    
    private historyLinkSubject = new BehaviorSubject<string | null>(null);
    currentHistoryLink = this.historyLinkSubject.asObservable();

    private Holderubject = new BehaviorSubject<boolean>(false);
    currentIsHolder = this.Holderubject.asObservable()

    private isqrGenerate = new BehaviorSubject<boolean>(false);
    currentIsqrGenerate = this.isqrGenerate.asObservable()

    private isCommunicationChannel = new BehaviorSubject<boolean>(false);
    currentCommunicationChannel = this.isCommunicationChannel.asObservable()
  
    private statusDocumentObject = new BehaviorSubject<boolean>(false);
    currentStatus = this.statusDocumentObject.asObservable()

    private selectedDocSubject = new BehaviorSubject<any>(null);
      selectedDoc$ = this.selectedDocSubject.asObservable();

       private triggerActionSource = new Subject<void>();
  triggerAction$ = this.triggerActionSource.asObservable();



    constructor(private http: HttpClient) { }

      triggerAction() {
    this.triggerActionSource.next();
  }

    setSelectedDoc(doc: any) {
        this.selectedDocSubject.next(doc);
    }

    getSelectedDoc() {
        return this.selectedDocSubject.value;
    }
    
    setIsHolder(value: boolean) {
        this.Holderubject.next(value);
    }

    statusDocument(value: boolean) {
        this.statusDocumentObject.next(value);
    }
    selectCard(cardIndex: number) {
        this.selectedCardSource.next(cardIndex);
    }

    changePinCode(value: string) {
        this.pinCodeSubject.next(value);
      }
    changePinHistoryCode(value: string) {
        this.pinHistoryCodeSubject.next(value);
      }
      
      setHistoryLink(value: string) {
        this.historyLinkSubject.next(value);
      }

    setIsPin(value: boolean) {
        this.isPinSource.next(value);
      }

      setQrGenerate(value: boolean) {
        this.isqrGenerate.next(value);
      }

      setCommunicationChannel(value: boolean) {
        this.isCommunicationChannel.next(value);
      }

    /** Stores translation labels; Arabic strings get bidi isolates for mixed script. */
    setLabels(value: Record<string, unknown>) {
        this.labels.next(wrapMixedLocaleBidiLabels(value));
    }

    getLabels() {
        return this.labels.asObservable();
    }

    getLabelsValue(): Record<string, unknown> | null {
        return this.labels.value;
    }

    /** Clears session storage but keeps the user's UI language for login/register. */
    clearLocalStoragePreservingLanguage(): void {
        const language = localStorage.getItem('language');
        localStorage.clear();
        if (language) {
            localStorage.setItem('language', language);
        }
    }

    setCountries(obj: any) {
        this.countries.next(obj);
    }

    setPreviousUploadedDocument(obj:any){
        return this.document.next(obj);
    }

    getPreviousUploadedDocument(){
        return this.document.asObservable();
    }

    getCountries() {
        return this.countries.asObservable();
    }

    setUserInfo(obj: any) {
        this.userInfo.next(obj);
    }

    getUserInfo() {
        return this.userInfo.asObservable();
    }


    setExtensionDocumentInfo(obj: any) {
        this.documentInfoFromExt.next(obj);
    }

    getExtensionDocumentInfo() {
        return this.documentInfoFromExt.asObservable();
    }

    setLoginPageStatus(isLoad: boolean) {
        this.isLoginPage.next(isLoad);
    }

    getLoginPageStatus() {
        return this.isLoginPage.asObservable();
    }

    setRemainigUpload(uploadCount: number) {
        this.remainingUpload.next(uploadCount);
    }

    getRemainingUploadCount() {
        return this.remainingUpload.asObservable();
    }

    setRemainigDigitalSignatures(uploadCount: number) {
        this.remainingDigitalUpload.next(uploadCount);
    }
    getRemainingDigitalSignatures() {
        return this.remainingDigitalUpload.asObservable();
    }

    setDocRefresh(isRefresh: boolean) {
        this.isDocRefresh.next(isRefresh);
    }

    getDocRefresh() {
        return this.isDocRefresh.asObservable();
    }

    setDocId(docId: any) {
        this.docId.next(docId);
    }

    getDocId() {
        return this.docId.asObservable();
    }

    setPageType(pageType: any) {
        this.pageType.next(pageType);
    }

    getPageType() {
        return this.pageType.asObservable();
    }

    setReset(isReset:boolean){
        this.isResetSection.next(isReset);
    }

    isReset(){
        return this.isResetSection.asObservable();
    }

    setDocumentDelete(isDelete:boolean){
        this.documentDelete=isDelete
    }

    isDocumentDelete(){
        return this.documentDelete;
    }
}